<div class="vertical-tabs-container">
	<mat-nav-list class="tabs-sidebar">
		<a
			mat-list-item
			*ngFor="let tab of tabs"
			(click)="selectTab(tab.id)"
			[class.active-tab]="selectedTab === tab.id"
		>
			<mat-icon matListIcon *ngIf="tab.icon">{{ tab.icon }}</mat-icon>
			<span matLine class="tab-label">
				<span class="tab-label-text">{{ tab.label }}</span>
				<span *ngIf="tab.invalid" class="tab-error-dot"></span>
			</span>
		</a>
	</mat-nav-list>

	<div class="tab-content">
		<div class="tab-header">
			<h2>{{ getSelectedTabLabel() }}</h2>
		</div>
		<div class="tab-body" #tabBody>
			<ng-container *ngFor="let content of tabContents">
				<ng-container
					*ngIf="content.tabId === selectedTab"
					[ngTemplateOutlet]="content.templateRef"
				></ng-container>
			</ng-container>
			<ng-content></ng-content>
		</div>
	</div>
</div>
